const devUrlOld = 'https://testscm.sousoushenbian.com'
const prodUrlOld = 'https://scm.sousoushenbian.com'
// const devUrlNew = 'https://scm.hxmeiwu.com'
const devUrlNew = 'https://scm.hongbaoliandong.com'
const prodUrlNew = 'https://scmback.hainanhongbao.com'
// let baseUrl = devUrlOld
let baseUrl = '/sapi'
if (window.location.origin.indexOf('testscmadmin.sousoushenbian.com') > 0) {
  baseUrl = devUrlOld
} else if (window.location.origin.indexOf('scmadmin.sousoushenbian.com') > 0) {
  baseUrl = prodUrlOld
} else if (window.location.origin.indexOf('scmadmin.hxmeiwu.com') > 0) {
  baseUrl = devUrlNew
} else if (window.location.origin.indexOf('scmadmin.hainanmeiwu.com') > 0) {
  baseUrl = prodUrlNew
} else if (window.location.origin.indexOf('scmadmin.hongbaoliandong.com') > 0) {
  baseUrl = devUrlNew
} else if (window.location.origin.indexOf('scmadmin.hainanhongbao.com') > 0) {
  baseUrl = prodUrlNew
}

export const BASE_API = baseUrl
